export default {
  name: 'Notification',
  data: function data() {
    return {};
  }
};